<div class="table-wrap-align manage-payer">
    <div class="title">
        <div class="modal-header lab-admin-model-header">
            <div class="ml-3">
                <div class="payer-lookup-header">Electronic Payer Lookup</div>
            </div>
            <img class="ml-auto cursor-pointer mr-3" mat-dialog-close src="/assets/icons/Close_white.svg" alt="cross"
                matTooltip="Close" #closeModal />
        </div>
    </div>
    <mat-dialog-content [ngClass]="searchData ? 'col-sm-12 parent-div npi-content' : 'parent-div-table npi-content'">
        <form [formGroup]="LookupForm" autocomplete="off" class="form-bg-color p-2">
            <div class="search-user-npi-feilds">
                <app-custom-input class="col-sm-3 pl-2 p-0 input-elements" formcontrolname="payerName"
                    labelValue="Electronic Payer Name" placeholder="Enter Electronic Payer Name"></app-custom-input>
                <app-custom-input class="col-sm-3 p-0 input-elements" formcontrolname="electronicPayerId"
                    labelValue="Electronic Payer ID" placeholder="Enter Electronic Payer ID"></app-custom-input>
                <div class="col-sm-2 p-0 mb-2 mt-1">
                    <app-button buttonclass="primary" class="npi-search-btn p-0" customClass="admin"
                        [isDisabled]="isLookupButtonDisabled" (click)="fetchMDMData()">
                        Lookup
                    </app-button>
                </div>
            </div>
        </form>

        <div class="col-sm-12 parent-div p-0 mt-2" *ngIf="searchData == true">
            <div class="px-4" *ngIf="isShimmer && searchData">
                <app-shimmerui [line]=5></app-shimmerui>
            </div>

            <div *ngIf="!isShimmer && searchData">
                <div *ngIf="PayerList?.length > 0 && !GridData">
                    <div class="p-1 px-2 npi-table-header pr-3">
                        <span></span>
                        <span>PAYER NAME</span>
                        <span>ELECTRONIC PAYER ID</span>
                        <span>ELECTRONIC PAYER</span>
                        <span>PAYER FAMILY</span>
                    </div>
                    <div class="payer-table-body" id="collapse-parent">
                        <div *ngFor="let item of PayerList; let j = index">
                            <div class="p-2 row-shadow npi-body-each-item"
                                (click)="handleRowClick(j, item, $event)" 
                                role="button" [aria-expanded]="selectedIndex === j ? 'true' : 'false'"
                                style="cursor: pointer;"
                                [ngClass]="{'table-body-background-color': j % 2 == 0, 'table-body-white-background-color': j % 2 != 0}">
                                <span>
                                    <input type="radio" [id]="'rad' + j" name="payerRadio"
                                        [checked]="selectedIndex === j && isSelected"
                                        (click)="[selectedRadioButton($event, item), $event.stopPropagation()]" />
                                </span>
                                <span class="npi-text-color payer-cell-text" 
                                    [title]="item.PayerName && item.PayerName !== 'N/A' && isTruncated('payerName' + j) ? item.PayerName : ''"
                                    [attr.data-cell-id]="'payerName' + j"
                                    (mouseenter)="checkTruncation($event, 'payerName' + j)">
                                    <b>{{item.PayerName || 'N/A'}}</b>
                                </span>
                                <span class="payer-cell-text" 
                                    [title]="item.ElectronicPayerID && item.ElectronicPayerID !== 'N/A' && isTruncated('electronicPayerId' + j) ? item.ElectronicPayerID : ''"
                                    [attr.data-cell-id]="'electronicPayerId' + j"
                                    (mouseenter)="checkTruncation($event, 'electronicPayerId' + j)">
                                    <b>{{item.ElectronicPayerID || 'N/A'}}</b>
                                </span>
                                <span class="payer-cell-text electronic-payer-icon">
                                    <span *ngIf="item.IsElectronicPayer">
                                        <img src="assets/icons/yes_check.svg" alt="Yes" />
                                    </span>
                                    <span *ngIf="!item.IsElectronicPayer">
                                        <img src="assets/icons/no_cross.svg" alt="No" />
                                    </span>
                                </span>
                                <span class="payer-cell-text" 
                                    [title]="item.PayerFamily && item.PayerFamily !== 'N/A' && isTruncated('payerFamily' + j) ? item.PayerFamily : ''"
                                    [attr.data-cell-id]="'payerFamily' + j"
                                    (mouseenter)="checkTruncation($event, 'payerFamily' + j)">
                                    <b>{{item.PayerFamily || 'N/A'}}</b>
                                </span>
                            </div>
                            <div [class.collapse]="PayerList.length > 1" 
                                [class.show]="selectedIndex === j && PayerList.length > 1"
                                [class.search-scroll]="PayerList.length <= 1">
                                <div class="" style="margin: 10px 58px 10px 58px;padding: 0px 22px 0px 22px;">
                                    <div class="row row-cols-4 justify-content-md-between">
                                        <div><b>Address :</b> <span>{{item.Address1 || item.address1 || 'N/A'}}
                                                {{(item.Address2 || item.address2) ? ', ' + (item.Address2 || item.address2) : ''}}</span></div>
                                        <!-- <div><span>Phone :</span> <span>{{item.Phone || 'N/A'}}</span></div>
                                        <div><span>Fax :</span> <span>{{item.Fax || 'N/A'}}</span></div>
                                        <div><span>Email :</span> <span>{{item.Email || 'N/A'}}</span></div> -->
                                    </div>
                                    <div class="row row-cols-4 justify-content-md-between mt-2">
                                        <div><b>Phone :</b> <span>{{item.Phone || item.phone || 'N/A'}}</span></div>
                                        <div><b>Fax :</b> <span>{{item.Fax || 'N/A'}}</span></div>
                                        <div><b>Email :</b> <span>{{item.Email || item.email || 'N/A'}}</span></div>
                                        <!-- <div><span>City :</span> <span>{{item.City || 'N/A'}}</span></div>
                                        <div><span>State :</span> <span>{{item.State || item.State1 || 'N/A'}}</span></div>
                                        <div><span>Zip Code :</span> <span>{{item.Zip || 'N/A'}}</span></div>
                                        <div><span>Billing Type :</span> <span>{{item.BillingType || 'N/A'}}</span></div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 nodata-header-wrap-popup" *ngIf="GridData">
                    <span class="col-sm-12 nodata-wrapper"> No Data Available </span>
                </div>
            </div>
        </div>
    </mat-dialog-content>

    <div [formGroup]="LookupForm" [ngClass]="!GridData ? 'col-sm-12 align-center mt-2 mb-2 pr-4' : 'col-sm-12 rtn-flex-end mt-2 mb-2'">
        <div class="col-sm-10 d-flex button-wrap p-0 align-center">
            <span class="toggle-font mr-2">Import Address Information:</span>
            <app-toggle-switch type="labadmin-primary" formcontrolname="addressandcontact" class="p-0 mr-4 pt-1">
            </app-toggle-switch>
        </div>
        <button type="button" class="col-sm-1 btn secondary mr-3" (click)="returnBtn()">Return</button>
        <button class="col-sm-1 btn primary" (click)="saveData()" *ngIf="!GridData"
            [disabled]="!isSelected">Import</button>
    </div>
</div>
